import React from 'react';
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { DatePicker } from "@/components/ui/DatePicker";
import { Label } from "@/components/ui/label";
import { Checkbox } from "@/components/ui/checkbox";
import { SearchableSelect } from "@/components/ui/SearchableSelect";
import DraggableModal from './DraggableModal';

const AddHolidayDialog = ({
  isOpen,
  onClose,
  // Form state
  holidayType,
  setHolidayType,
  holidayName,
  setHolidayName,
  holidayDate,
  setHolidayDate,
  holidayRecurring,
  setHolidayRecurring,
  holidayIsFullDay = true,
  setHolidayIsFullDay,
  holidayHalfPeriod = 'afternoon',
  setHolidayHalfPeriod,
  // Actions
  onSubmit,
  loading
}) => {
  return (
    <DraggableModal
      isOpen={isOpen}
      onClose={onClose}
      title="Tatil Ekle"
      maxWidth="max-w-md"
    >
      <div className="space-y-4">
        <div className="space-y-2">
          <Label>Tatil Türü</Label>
          <SearchableSelect
            value={holidayType}
            onChange={setHolidayType}
            showAllOption={false}
            placeholder="Tatil türü seçin"
            searchPlaceholder="Tatil türü ara..."
            options={[
              { id: "resmi_tatil", name: "🔴 Resmi Tatil" },
              { id: "idari_tatil", name: "🟣 İdari Tatil" },
            ]}
          />
        </div>

        <div className="space-y-2">
          <Label>Gün Kapsamı</Label>
          <SearchableSelect
            value={holidayIsFullDay ? 'full' : 'half'}
            onChange={(v) => setHolidayIsFullDay && setHolidayIsFullDay(v === 'full')}
            showAllOption={false}
            placeholder="Gün kapsamı seçin"
            searchPlaceholder="Kapsam ara..."
            options={[
              { id: "full", name: "Tam Gün" },
              { id: "half", name: "Yarım Gün" },
            ]}
          />
        </div>

        {!holidayIsFullDay && (
          <div className="space-y-2">
            <Label>Tatil Olan Yarı</Label>
            <SearchableSelect
              value={holidayHalfPeriod}
              onChange={(v) => setHolidayHalfPeriod && setHolidayHalfPeriod(v)}
              showAllOption={false}
              placeholder="Yarı seçin"
              searchPlaceholder="Seçenek ara..."
              options={[
                { id: "afternoon", name: "Öğleden Sonra Tatil (Sabah Mesai)" },
                { id: "morning", name: "Sabah Tatil (Öğleden Sonra Mesai)" },
              ]}
            />
          </div>
        )}

        <div className="space-y-2">
          <Label>Tatil Adı *</Label>
          <Input 
            value={holidayName} 
            onChange={(e) => setHolidayName(e.target.value)}
            placeholder="Örn: 15 Temmuz Demokrasi Bayramı"
          />
        </div>
        
        <div className="space-y-2">
          <DatePicker
            label="Tarih"
            required
            value={holidayDate}
            onChange={setHolidayDate}
          />
        </div>
        
        <div className="flex items-center gap-2">
          <Checkbox 
            checked={holidayRecurring} 
            onCheckedChange={setHolidayRecurring}
          />
          <Label>Her yıl tekrarlar</Label>
        </div>
      </div>

      <div className="flex gap-2 mt-4">
        <Button variant="outline" onClick={onClose} className="flex-1">
          İptal
        </Button>
        <Button onClick={onSubmit} disabled={loading} className="flex-1">
          {loading ? 'Ekleniyor...' : 'Tatil Ekle'}
        </Button>
      </div>
    </DraggableModal>
  );
};

export default AddHolidayDialog;
